var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailInfo",
              attrs: { title: "LBL0003715", collapsed: true },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable &&
                      _vm.popupParam.noPlan === "Y" &&
                      !_vm.updateMode &&
                      !_vm.disabled
                        ? _c("c-btn", {
                            attrs: { label: "LBLSELECT", icon: "add" },
                            on: { btnClicked: _vm.add },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.updateMode && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "LBLCOMPLETE",
                              icon: "save",
                              color: "blue",
                            },
                            on: { btnClicked: _vm.resultComplete },
                          })
                        : _vm._e(),
                      _vm.editable && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.result,
                              mappingType: _vm.saveType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveInspection,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _vm.editable && !_vm.result.equipmentCd
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [_c("c-label-text", { attrs: { title: "LBL0003716" } })],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.plantName
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBLPLANT",
                            value: _vm.result.plantName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.equipmentTypeCd
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0000633",
                            value: _vm.result.equipmentTypeName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.equipmentCd
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0003705",
                            value: _vm.result.equipmentCd,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.equipmentName
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0000632",
                            value: _vm.result.equipmentName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.recentInspectionDate
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0003717",
                            value: _vm.result.recentInspectionDate,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.inspectionCycleName
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0003609",
                            value: _vm.result.inspectionCycleName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.nextMonth
                  ? _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0003718",
                            value: _vm.result.nextMonth,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.relatedLawsName
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "LBL0003610",
                            value: _vm.result.relatedLawsName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0003719", bgClass: "" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            label: "LBL0003608",
                            disabled: _vm.disabled,
                            required: "",
                            codeGroupCd: "MDM_CHECK_KIND_CD",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "equipmentCheckKindCd",
                          },
                          model: {
                            value: _vm.result.equipmentCheckKindCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "equipmentCheckKindCd", $$v)
                            },
                            expression: "result.equipmentCheckKindCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-dept", {
                          attrs: {
                            label: "LBL0003605",
                            required: true,
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.result.checkDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkDeptCd", $$v)
                            },
                            expression: "result.checkDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            label: "LBL0003706",
                            name: "checkUserId",
                            type: "user",
                          },
                          model: {
                            value: _vm.result.checkUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkUserId", $$v)
                            },
                            expression: "result.checkUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "LBL0003707",
                            name: "checkDate",
                          },
                          model: {
                            value: _vm.result.checkDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkDate", $$v)
                            },
                            expression: "result.checkDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-moc", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "LBLMOCNO",
                            name: "sopMocId",
                          },
                          model: {
                            value: _vm.result.sopMocId,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "sopMocId", $$v)
                            },
                            expression: "result.sopMocId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            codeGroupCd: "MIM_CHECK_RESULT_CD",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            required: "",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "checkResultCd",
                            label: "LBL0003607",
                          },
                          model: {
                            value: _vm.result.checkResultCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkResultCd", $$v)
                            },
                            expression: "result.checkResultCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-plant", {
                          attrs: { disabled: _vm.disabled },
                          model: {
                            value: _vm.result.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "plantCd", $$v)
                            },
                            expression: "result.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "LBL0003708",
                            name: "checkResultSummary",
                          },
                          model: {
                            value: _vm.result.checkResultSummary,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkResultSummary", $$v)
                            },
                            expression: "result.checkResultSummary",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c("c-tab", {
            attrs: {
              type: "tabcard",
              tabItems: _vm.tabItems,
              inlineLabel: true,
              align: "left",
            },
            on: {
              "update:tabItems": function ($event) {
                _vm.tabItems = $event
              },
              "update:tab-items": function ($event) {
                _vm.tabItems = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (tab) {
                  return [
                    _c(tab.component, {
                      tag: "component",
                      attrs: { result: _vm.result },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }